import { render, staticRenderFns } from "./PreviewDocument.vue?vue&type=template&id=be8bc906"
import script from "./PreviewDocument.vue?vue&type=script&lang=ts"
export * from "./PreviewDocument.vue?vue&type=script&lang=ts"
import style0 from "./PreviewDocument.vue?vue&type=style&index=0&id=be8bc906&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports